import { render, staticRenderFns } from "./FrameworkSwitcherDialog.vue?vue&type=template&id=0840578e"
import script from "./FrameworkSwitcherDialog.vue?vue&type=script&lang=js"
export * from "./FrameworkSwitcherDialog.vue?vue&type=script&lang=js"
import style0 from "./FrameworkSwitcherDialog.vue?vue&type=style&index=0&id=0840578e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports